"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useProduct = useProduct;
var _router = _interopRequireDefault(require("@/router"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function useProduct() {
  //商品类型
  var productTypeList = [{
    label: '普通商品',
    value: 0
  }
  // {
  //   label: '虚拟商品',
  //   value: 2,
  // },
  // {
  //   label: '云盘商品',
  //   value: 5,
  // },
  // {
  //   label: '卡密商品',
  //   value: 6,
  // },
  // {
  //   label: '预约商品',
  //   value: 7,
  // },
  ];

  //创建、编辑表单
  var handlerCreatFromUse = function handlerCreatFromUse(id, type) {
    var _router$resolve = _router.default.resolve({
        path: "/page/maintain/creatSystemFrom/".concat(id, "/").concat(type)
      }),
      href = _router$resolve.href;
    window.open(href);
  };
  return {
    productTypeList: productTypeList,
    handlerCreatFromUse: handlerCreatFromUse
  };
}